export const colourStyles = {
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  control: (styles: any) => ({
    ...styles,
    backgroundColor: "white",
    borderColor: "rgba(145, 158, 171, 0.24)",
    boxShadow: "none",
    height: 53,
    ":hover": {
      borderColor: "rgba(145, 158, 171, 0.24)",
    },
  }),
  option: (styles: any, { data, isDisabled, isFocused, isSelected }: any) => {
    return {
      ...styles,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      backgroundColor: isDisabled
        ? undefined
        : isSelected
        ? data.color
        : isFocused
        ? "var(--fow-gray-light-color)"
        : undefined,

      color: isDisabled ? "#ccc" : isSelected,
      cursor: isDisabled ? "not-allowed" : "default",

      ":active": {
        ...styles[":active"],
        backgroundColor: !isDisabled
          ? isSelected
            ? data.color
            : "var(--fow-gray-light-color)"
          : undefined,
      },
    };
  },
};
